module.exports = __webpack_public_path__ + "static/media/logo.b2ae3b14.png";